import * as React from 'react';
import refershIcon from './refreshIcon.svg'
const Refresh = props => {
  return (
  <React.Fragment>
    <img {...props} src ={refershIcon}  />
  </React.Fragment>
  );
};


export default Refresh;
